import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoGridOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import axios from "axios";
import { setUserDetails } from "../../store/userSlice";
import { useNavigate } from "react-router-dom";
import Luckywheel from "./Luckywheel";
import SummaryApi from "../../common";
import { useDispatch, useSelector } from "react-redux";
import style from '../Styles/userDashboard.module.css';
import imageTobase64 from "../../helpers/imageTobase64";

const Dashboard = ({ setShowDash }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [newProfilePic, setNewProfilePic] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get("https://cinevabackend.onrender.com/api/user-details", {
          withCredentials: true,
        });
        setUser(response.data.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/Login");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const base64Image = await imageTobase64(file);
    setNewProfilePic(base64Image);
  };

  const handleUpdateProfilePic = async () => {
    if (!newProfilePic) return;

    try {
      const response = await axios.put(
        "https://cinevabackend.onrender.com/api/update-profile-pic",
        { profilePic: newProfilePic },
        { withCredentials: true }
      );

      if (response.data.success) {
        setUser((prev) => ({ ...prev, profilePic: newProfilePic }));
        setNewProfilePic(null);
      }
    } catch (error) {
      console.error("Error updating profile picture:", error);
    }
  };

  // calling the logout api
  const handleLogout = async () => {
    try {
      const fetchData = await fetch(SummaryApi.logout_user.url, {
        method: SummaryApi.logout_user.method,
        credentials: "include",
      });

      const data = await fetchData.json();

      if (data.success) {
        toast.success(data.message);
        dispatch(setUserDetails(null)); // Clear Redux user
        setUser(null);                  // Clear local state
        if (setShowDash) setShowDash(false); // Close Dashboard if it's modal
        navigate("/Login");            // Redirect to login
      } else if (data.error) {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error("Logout failed. Try again.");
      console.error("Logout Error:", err);
    }
  };


  const showWheel = () => {
    setShowSpinner(true);
  };

  const closeDashboard = () => {
    if (setShowDash) setShowDash(false); // Check before calling
  };

  return (
    <>
      {user && (
        <>
          {setShowDash && (
            <div
              style={{
                position: "fixed",
                top: "3.5em",
                bottom: "0",
                left: "0",
                right: "0",
                zIndex: "11"
              }}
              onClick={closeDashboard}
            ></div>
          )}
          <div className={style.userDashboard}>
            <div className={style.dashboardContent}>
              {/* Profile Picture */}
              <div className={style.profileSection}>
                <img src={user.profilePic || "../images/signin.gif"} alt="Profile" className={style.profilePic} />
                <label className={style.uploadBtn}>
                  Change Photo
                  <input
                    placeholder="Upload New Photo"
                    autoComplete="off"
                    type="file"
                    className={style.picfile}
                    onChange={handleUploadPic}
                  />
                </label>
                {newProfilePic && (
                  <button className={style.uploadBtn} onClick={handleUpdateProfilePic}>Update Profile Pic</button>
                )}
              </div>

              {/* User Info */}
              <div className={style.userDetails}>
                <p><strong>Name:</strong> {user.name}</p>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Tokens:</strong> {user.tokens}</p>
              </div>

              <div className={style.actionBtn} onClick={() => { showWheel() }}>
                Lucky Wheel
              </div>
              <div >
                <Link to="/Upgrade" className={style.actionBtn}>
                  Upgrade Plans
                </Link>
              </div>




              {/* Logout Button */}
              <button onClick={handleLogout} className={style.logoutBtn}>Logout</button>
            </div>
          </div>
        </>
      )}

      {/* Spin Wheel */}
      {user && showSpinner && (
        <Luckywheel
          setShowSpinner={setShowSpinner}
          userId={user._id}
          updateUserTokens={(tokens) => setUser({ ...user, tokens })}
          showToken={user.tokens}
        />
      )}





    </>
  );
};

export default Dashboard;
